import React from 'react';
import classes from './HLInfoRow.module.scss';
import cn from 'classnames';

export enum HLInfoRowStyleType {
    DEFAULT = 'DEFAULT',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    CLICKABLE = 'CLICKABLE',
}

export enum HLInfoRowSizeType {
    DEFAULT = 'DEFAULT',
    SMALL = 'SMALL',
}

interface HLInfoRowProps {
    label?: React.ReactNode;
    value: React.ReactNode;
    styleType?: HLInfoRowStyleType;
    sizeType?: HLInfoRowSizeType;
    onClick?: () => void;
}

const HLInfoRow: React.FC<HLInfoRowProps> = (
    {
        label,
        value,
        styleType = HLInfoRowStyleType.DEFAULT,
        sizeType = HLInfoRowSizeType.DEFAULT,
        onClick
    }) => {
    const valueClassNames = cn(classes.value, {
        [classes.valueSuccess]: styleType === HLInfoRowStyleType.SUCCESS,
        [classes.valueError]: styleType === HLInfoRowStyleType.ERROR,
        [classes.valueClickable]: styleType === HLInfoRowStyleType.CLICKABLE,
    });

    const infoRowClassNames = cn(classes.infoRow, {
        [classes.infoRowSmall]: sizeType === HLInfoRowSizeType.SMALL,
    });

    return (
        <div className={infoRowClassNames}>
            {label && <span className={classes.label}>{label}</span>}
            <span 
                className={valueClassNames}
                onClick={onClick}
            >
                {value}
            </span>
        </div>
    );
};

export default HLInfoRow; 